import React from "react";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { MAX_AI_TEXT_LENGTH_DEFAULT, REQUEST_URL } from "../Config";
import LoadingBar from "react-top-loading-bar";
import { useContext } from "react";
import { LoggedInContext } from "../../App";
import { googleLogout } from "@react-oauth/google";

function AccountDetailsContent() {
  //navigate
  const navigate = useNavigate(); //react router navigate

  //
  //get ai detector values
  // eslint-disable-next-line no-unused-vars
  const { isLoggedIn, setIsLoggedIn, setMaxAITextLength } =
    useContext(LoggedInContext);

  //account detals
  const [accountDetails, setAccountDetails] = useState({
    email_id: "",
    email_id_verified: 0,
    number_of_requests: 0,
    character_processed_count: 0,
    max_character_purchased_count: 0,
    max_character_process_at_a_time: 700,
    subscription_name: "TRIAL",
    created_at: "00:00:00",
  });

  //loading progress
  const [progress, setProgress] = useState(0);

  //flag initialized
  const initialized = useRef(false);

  // Function to simulate progress updates
  const startLoading = () => {
    setProgress(30); // Start with some progress
    // Simulate an async operation
    setTimeout(() => {
      setProgress(70);
    }, 500);
  };

  //run for once at startup
  useEffect(() => {
    //check
    if (initialized.current === false) {
      //check
      //if logged in
      //set
      initialized.current = true;
      //call endpoint
      accountDetailsEndpoint();
      //start loading
      startLoading();

      console.log("Loading account details");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //account details endpoint
  const accountDetailsEndpoint = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "GET_ACCOUNT_DETAILS",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //scroll to top
        window.scrollTo(0, 0);
        //check
        if (data.success === true) {
          //check
          if (data.response.length > 0) {
            //set details
            setAccountDetails({
              ...accountDetails,
              email_id: data.response[0].email_id,
              email_id_verified: data.response[0].email_id_verified,
              number_of_requests: data.response[0].number_of_requests,
              character_processed_count:
                data.response[0].character_processed_count,
              max_character_purchased_count:
                data.response[0].max_character_purchased_count,
              max_character_process_at_a_time:
                data.response[0].max_character_process_at_a_time,
              subscription_name: data.response[0].subscription_name,
              created_at: data.response[0].created_at,
            });

            //set
            setMaxAITextLength(
              Math.max(
                MAX_AI_TEXT_LENGTH_DEFAULT,
                data.response[0].max_character_process_at_a_time
              )
            );
          }
        }

        // Simulate an async operation
        setTimeout(() => {
          //set progress
          setProgress(100);
        }, 500);

        console.log("Response Data:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        // Simulate an async operation
        setTimeout(() => {
          //set progress
          setProgress(100);
        }, 500);
      });
  };

  return (
    <div>
      <LoadingBar
        progress={progress}
        onLoaderFinished={() => setProgress(0)} // Reset on completion
      />
      <div className="p-3">
        <div className="container">
          <div style={{ marginTop: "6rem" }}>
            {/* title */}
            <h1 className="display-6 text-center mt-2">My Account</h1>

            {/* Show hide account details */}
            {isLoggedIn.is_logged_in ? (
              <div>
                {/* Verify Email ID Button */}
                <div className="justify-content-md-center text-center mt-5">
                  <button
                    className={`btn btn-success mt-1 px-5 rounded-pill ${
                      accountDetails.email_id_verified === 1 ? "d-none" : ""
                    }`}
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Verify email address"
                    type="button"
                    onClick={(e) => {
                      //blur
                      e.target.blur();
                      //Navigate to verify email page
                      navigate("/verify_email", {
                        state: {
                          email_address_login: accountDetails.email_id,
                        },
                      }); //Navigate to verify email page
                    }}
                  >
                    Verify Email Address
                  </button>
                </div>

                {/* Account Details */}
                <div className="row justify-content-md-center mt-5">
                  {/* Account Details Left */}
                  <div className="col-md-3">
                    <img
                      className="mt-5"
                      src="./images/account.png"
                      style={{ width: "100px", height: "100px" }}
                      alt="account"
                    ></img>
                    <div>
                      <label
                        className="mt-3 text-muted fs-5"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Email Address"
                      >
                        {accountDetails.email_id}{" "}
                        {accountDetails.email_id_verified === 1 ? (
                          <img
                            src="./images/tick.png"
                            alt="success"
                            className="ms-1 position-relative"
                            style={{
                              width: "20px",
                              height: "20px",
                              bottom: "2px",
                            }}
                          />
                        ) : (
                          <button
                            className="btn btn-clear btn-sm text-primary position-relative"
                            style={{ bottom: "1px" }}
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Verify email address"
                            type="button"
                            onClick={(e) => {
                              //blur
                              e.target.blur();
                              //Navigate to verify email page
                              navigate("/verify_email", {
                                state: {
                                  email_address_login: accountDetails.email_id,
                                },
                              }); //Navigate to verify email page
                            }}
                          >
                            Verify
                          </button>
                        )}
                      </label>
                      <div>
                        <label
                          className="text-muted mt-2 text-left"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Account created on"
                        >
                          {accountDetails.created_at}
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Account details right */}
                  <div className="col-md-4">
                    {/* Account activity */}
                    <h3 className="mt-5">Account Activity</h3>

                    <p className="mt-4 lead text-muted">
                      <span
                        className="text-dark"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Number of requests processed"
                      >
                        Processed:
                      </span>{" "}
                      {accountDetails.number_of_requests}{" "}
                      <span className="fs-5">(requests)</span>
                    </p>

                    <p className="mt-3 lead text-muted">
                      <span
                        className="text-dark"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Purchased characters processing units will be added here"
                      >
                        Total Credit:
                      </span>{" "}
                      {accountDetails.max_character_purchased_count}{" "}
                      <span className="fs-5">(characters)</span>
                      <button
                        className="btn btn-clear text-primary"
                        type="button"
                        onClick={(e) => {
                          //Navigate to pricing page
                          navigate("/pricing"); //Navigate to pricing page
                        }}
                      >
                        Add Credit
                      </button>
                    </p>

                    <p className="mt-3 lead text-muted">
                      <span
                        className="text-dark"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Remaining characters processing units available from your purchased units"
                      >
                        Remaining Credit:
                      </span>{" "}
                      {accountDetails.max_character_purchased_count -
                        accountDetails.character_processed_count}{" "}
                      <span className="fs-5">(characters)</span>
                    </p>

                    {/* Subscription */}
                    <h3 className="mt-5">Payment Details</h3>

                    <p className="mt-4 lead text-muted">
                      <span className="text-dark">Purchase details:</span>{" "}
                      {accountDetails.subscription_name + " PACK"}
                    </p>
                    <p className="mt-4 lead text-muted">
                      <span className="text-dark">Purchased on:</span>{" "}
                      {accountDetails.created_at}
                    </p>
                  </div>
                </div>

                {/* Logout Button */}
                <div className="d-flex justify-content-center">
                  <button
                    className="btn btn-danger mt-5 btn-lg mx-auto px-5 rounded-pill"
                    onClick={(e) => {
                      //blur
                      e.target.blur();
                      //clear token
                      //set token
                      //get access token which user was using while logged out
                      //to get previous account id
                      localStorage.setItem(
                        "access_token",
                        localStorage.getItem("access_token_saved")
                      );
                      //logout from google
                      googleLogout();
                      //set
                      setIsLoggedIn({ ...isLoggedIn, is_logged_in: false });
                      //set
                      setMaxAITextLength(MAX_AI_TEXT_LENGTH_DEFAULT);

                      console.log("Logged out");
                    }}
                  >
                    Logout
                  </button>
                </div>
              </div>
            ) : (
              <div className="justify-content-center text-center">
                <h1 className="display-5 text-center mt-5 text-danger">
                  Sorry, User not logged in.
                </h1>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountDetailsContent;
